import { config } from '@/config'
// import eventSystem from '@/lib/event-system/index.js'

const cookiesDomain = config.baseUrl.replace('https://', '.')
const env = config.envFullName

export const actions = {
  async nuxtServerInit ({ state, commit, dispatch }, { app, req }) {
    const locale = state.i18n.locale
    const currentRouteName = app.context.route.name

    app.head.script.filter((script) => {
      if (script.hid === 'freshdesk-widget-init') {
        script.innerHTML = `window.fwSettings={ widget_id: 44000001365, locale: '${locale}' }; !function(){if("function"!=typeof window.FreshworksWidget){var n=function(){n.q.push(arguments)};n.q=[],window.FreshworksWidget=n}}()`
      }
      return script
    })

    if (currentRouteName && !currentRouteName.includes('___' + locale)) {
      return
    }

    if (process.env.INSPECT_NODE && global.gc) {
      setTimeout(() => {
        console.log('Start force garbage collection for test on local dev (npm run dev-inspect):')
        global.gc()
      }, 20 * 1000)
    }

    // Set user current country
    if (req.headers && req.headers['cloudfront-viewer-country']) {
      const userCurrentLocation = req.headers['cloudfront-viewer-country']
      commit('auth/setCurrentCountry', userCurrentLocation)
    }

    // Check AWS status
    await dispatch('app/updateAppStatus')
  },

  nuxtClientInit ({ state, commit, dispatch }, { app }) {
    // --- Auth initialization (client-only) ---
    const idToken = app.$cookiz.get('RSS_IT')
    const accessToken = app.$cookiz.get('RSS_AT')
    const refreshToken = app.$cookiz.get('RSS_RT')

    const clearCookiesTokens = () => {
      app.$cookiz.remove('RSS_IT', { path: '/', secure: true, domain: cookiesDomain })
      app.$cookiz.remove('RSS_AT', { path: '/', secure: true, domain: cookiesDomain })
      app.$cookiz.remove('RSS_RT', { path: '/', secure: true, domain: cookiesDomain })
      app.$cookiz.remove('RSS_EXPIRED_IN')
    }

    const hasValidTokens = idToken && accessToken && refreshToken &&
      idToken !== 'undefined' && accessToken !== 'undefined' && refreshToken !== 'undefined'

    if (hasValidTokens) {
      // Defer auth state to after hydration to avoid mismatch breaking event listeners
      setTimeout(() => {
        try {
          dispatch('auth/signInInitTokens', { idToken, accessToken, refreshToken })
          commit('auth/setAuthStateFromIdToken', idToken)
          commit('auth/setLoginStatus', true)
          dispatch('auth/setUserProfilePictureUrls')

          // Sentry user context
          const userEmail = state.auth.email
          if (userEmail && app.$sentry) {
            app.$sentry.configureScope(function (scope) {
              scope.setUser({ email: userEmail })
            })
          }

          // Fetch GDPR and language in background (non-blocking for UI)
          dispatch('auth/gdprDataGet', idToken).then((gdprResponse) => {
            if (!gdprResponse) {
              clearCookiesTokens()
              commit('auth/setLoginStatus', false)
            }
          }).catch((error) => {
            console.error('Error with set GDPR:', error.message)
          })

          dispatch('auth/getUserLanguage').then((userLanguage) => {
            if (userLanguage) {
              commit('auth/setDashboardLanguage', userLanguage)

              // Client-side language redirect
              const currentLocale = state.i18n.locale
              if (userLanguage !== currentLocale) {
                let newPath = app.context.route.fullPath.replace('/' + currentLocale + '/', '/')
                if (userLanguage !== 'en') {
                  newPath = '/' + userLanguage + newPath
                }
                app.router.push(newPath)
              }
            }
          }).catch((error) => {
            console.error('Error fetching user language:', error.message)
          })
        } catch (error) {
          console.error('Error with client auth init:', error.message)
          clearCookiesTokens()
        }
      }, 0)
    } else if (idToken || accessToken || refreshToken) {
      // Partial/invalid tokens — clear them
      clearCookiesTokens()
    }

    // --- Existing client init logic ---

    // registration of global setInterval
    setInterval(() => {
      dispatch('app/updateAppStatus', {}, { root: true })
    }, 1000 * 60) // 1 min

    const thirdPartyScriptsAccepted = app.$cookiz.get('RSS_GDPR_TPART')

    // eslint-disable-next-line
    window.dataLayer = window.dataLayer || []
    // eslint-disable-next-line
    window.dataLayer.push({
      env
    })

    const userEmail = state.auth.email

    if (thirdPartyScriptsAccepted !== 'false' && thirdPartyScriptsAccepted !== false) {
      app.$gtm.init()
    }

    // ProfitWell event
    if (userEmail && thirdPartyScriptsAccepted !== 'false' && thirdPartyScriptsAccepted !== false) {
      app.$gtm.push({ event: 'start_pw', pw_user_email: userEmail })
    }
  }
}
